export enum ImportPermissions {
  Import = 'import',
  ImportFiles = 'import-files',
}
